function TitleContainerComponent(props) {

    return (
        <div
            className="p-3"
            style={{
                textAlign: 'center',
            }}>
            {props.children}
        </div>
    );
}

export default TitleContainerComponent;